jQuery(document).ready(function( $ ){

	// AOS
	AOS.init();

	// END JQUERY
});
